import { Http } from 'vrlcm-gui-utils';
import { LockerApiUri } from './uri';
import {
  CreateCertificateDto,
  Certificate,
  ImportCertificateDto
} from 'vrlcm-gui-types';

export class CertificateApi {
  public static async generateCertificate(payload: CreateCertificateDto) {
    const res = await Http.post<Certificate>(
      LockerApiUri.CertificateV2.CERTIFICATES_BASE_URL,
      payload
    );
    return res.data;
  }

  public static async importCertificate(payload: ImportCertificateDto) {
    const res = await Http.post<Certificate>(
      LockerApiUri.CertificateV2.IMPORT_CERTIFICATE_URL,
      payload
    );
    return res.data;
  }

  public static async validateCertificateFile(file: File, passphrase: string) {
    const formData = new FormData();
    formData.append('bundle', file, file.name);
    formData.append('passphrase', passphrase);
    const res = await Http.post<Certificate>(
      LockerApiUri.Certificate.VALIDATE_CERTIFICATE_FILE_URL,
      formData
    );
    return res.data;
  }
}
